import { all, fork } from 'redux-saga/effects';
import {
  fetchAppointmentReportsSaga,
  generateReportSaga,
  generateEncounterReportSaga,
  fetchFaxLogsByAppointmentSaga,
  uploadMRRFilesSaga,
  fetchAppointmentByDateSaga,
  downloadArchiveSaga,
  getAppointmentReportsByIdSaga,
  fetchS3AccessUrlSaga,
} from './containers/Appointment/sagas';
import {
  fetchEncounterNoteSaga,
  fetchEncounterNoteSectionSaga,
  batchUpdateProviderEncounterSaga,
  eSignEncounterNoteSaga,
  updateEncounterDataSaga,
  uploadEncounterNoteAttachmentSaga,
  fetchEncounterByIdSaga,
  fetchEncounterChartImportBySectionIdApiSaga,
  postEncounterChartImportApiSaga,
} from './containers/EncounterNote/sagas';

import {
  fetchMasterOrdersSaga,
  fetchPatientOrdersByIdSaga,
  postPatientOrderSaga,
  putPatientOrderByIdSaga,
  fetchPatientDiagnosisByIdSaga,
  fetchAppointmentOrdersByIdSaga,
} from './containers/RxOrders/sagas';

import {
  fetchPatientRxMedicationsByIdSaga,
  postCreateRxMedicationsSaga,
  putPatientRxMedicationByIdSaga,
  fetchPatientsActiveAllergiesSaga,
  fetchPatientsCurrentMedicationsSaga,
  fetchAppointmentMedicationsByIdSaga,
} from './containers/RxMedications/sagas';
import { fetchOutcomeAnalyticsSaga } from './containers/PatientOutcomes/sagas';
import {
  fetchApptServiceSaga,
  postHistoryFlowSaga,
  putHistoryFlowSaga,
  postMrrFlowSaga,
  putMrrFlowSaga,
  postScribeFlowSaga,
  putScribeFlowSaga,
  postRfaFlowSaga,
  putRfaFlowSaga,
  putInsuranceDetailsSaga,
  fetchAppointmentsByDateSaga,
  fetchAppointmentsByPatientSaga,
  fetchFlowSummariesByDateSaga,
  putHistoryFileUrlsSaga,
  putMrrFileUrlsSaga,
  putRfaFileUrlsSaga,
  putScribeFileUrlsSaga,
  putHistoryNotesSaga,
  putMrrNotesSaga,
  putRfaNotesSaga,
  putScribeNotesSaga,
  fetchMrrByAppointmentIdSaga,
  fetchPatientDetailsSaga,
  fetchNotificationsSaga,
  markNotificationSeenSaga,
} from './containers/AppointmentService/sagas';

import { fetchExternalContactsSaga, fetchDocsReceivedSaga, fetchDocsSentSaga, postExternalContactSaga, putExternalContactSaga, putSecureShareDocSaga } from './containers/SecureShare/sagas';

import { getPatientProfileSaga, fetchFolderDocsByPatientIdSaga, fetchPatientFolderSaga } from './containers/Patient/sagas';

export default function* root() {
  yield all([
    fork(fetchAppointmentReportsSaga),
    fork(generateReportSaga),
    fork(generateEncounterReportSaga),
    fork(fetchEncounterNoteSaga),
    fork(fetchEncounterNoteSectionSaga),
    fork(fetchOutcomeAnalyticsSaga),
    fork(batchUpdateProviderEncounterSaga),
    fork(eSignEncounterNoteSaga),
    fork(updateEncounterDataSaga),
    fork(uploadEncounterNoteAttachmentSaga),
    fork(fetchEncounterByIdSaga),
    fork(fetchFaxLogsByAppointmentSaga),
    fork(uploadMRRFilesSaga),
    fork(fetchAppointmentByDateSaga),
    fork(downloadArchiveSaga),
    fork(fetchEncounterChartImportBySectionIdApiSaga),
    fork(postEncounterChartImportApiSaga),
    fork(getAppointmentReportsByIdSaga),
    fork(fetchS3AccessUrlSaga),
    // RxOrders
    fork(fetchMasterOrdersSaga),
    fork(fetchPatientOrdersByIdSaga),
    fork(postPatientOrderSaga),
    fork(putPatientOrderByIdSaga),
    fork(fetchPatientDiagnosisByIdSaga),
    fork(fetchAppointmentOrdersByIdSaga),
    // RxMedications
    fork(fetchPatientRxMedicationsByIdSaga),
    fork(postCreateRxMedicationsSaga),
    fork(putPatientRxMedicationByIdSaga),
    fork(fetchPatientsActiveAllergiesSaga),
    fork(fetchPatientsCurrentMedicationsSaga),
    fork(fetchAppointmentMedicationsByIdSaga),

    // Patient
    fork(getPatientProfileSaga),
    fork(fetchFolderDocsByPatientIdSaga),
    fork(fetchPatientFolderSaga),
    // Appt Service
    fork(fetchApptServiceSaga),
    fork(postHistoryFlowSaga),
    fork(putHistoryFlowSaga),
    fork(postMrrFlowSaga),
    fork(putMrrFlowSaga),
    fork(postScribeFlowSaga),
    fork(putScribeFlowSaga),
    fork(postRfaFlowSaga),
    fork(putRfaFlowSaga),
    fork(putInsuranceDetailsSaga),
    fork(fetchAppointmentsByDateSaga),
    fork(fetchAppointmentsByPatientSaga),
    fork(fetchFlowSummariesByDateSaga),
    fork(putHistoryFileUrlsSaga),
    fork(putMrrFileUrlsSaga),
    fork(putRfaFileUrlsSaga),
    fork(putScribeFileUrlsSaga),
    fork(putHistoryNotesSaga),
    fork(putMrrNotesSaga),
    fork(putRfaNotesSaga),
    fork(putScribeNotesSaga),
    fork(fetchMrrByAppointmentIdSaga),
    fork(fetchPatientDetailsSaga),
    fork(fetchNotificationsSaga),
    fork(markNotificationSeenSaga),

    // Secure Share
    fork(fetchExternalContactsSaga),
    fork(fetchDocsReceivedSaga),
    fork(fetchDocsSentSaga),
    fork(postExternalContactSaga),
    fork(putExternalContactSaga),
    fork(putSecureShareDocSaga),
  ]);
}
